import { useMemo } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { parse } from "qs";

import { leaflyShopStringify } from "@/utils/qs";

const useSortQueryParam = () => {
  const path = usePathname();
  const searchParams = useSearchParams();

  const { appliedSort, nonSortQueryParams } = useMemo(() => {
    const parsedQs = parse(searchParams?.toString() || "");
    const { sort: appliedSort, page: _page, ...nonSortQueryParams } = parsedQs;

    return {
      // * Assuming this hook is used to manage sort, we can confidently say it is a string record (see getUrlWithNewSort)
      appliedSort: appliedSort as { [key: string]: string },
      nonSortQueryParams,
    };
  }, [searchParams]);

  const getUrlWithNewSort = (name: string, newFilterValue: string) => {
    return {
      pathname: path,
      query: leaflyShopStringify({
        ...nonSortQueryParams,
        sort: {
          [name]: newFilterValue,
        },
      }),
    };
  };

  const getUrlWithoutSort = () => {
    return {
      pathname: path,
      query: leaflyShopStringify({
        ...nonSortQueryParams,
      }),
    };
  };

  return {
    appliedSort,
    utils: {
      getUrlWithNewSort,
      getUrlWithoutSort,
    },
  };
};

export default useSortQueryParam;
